import { AuthUtils } from "../../auth/utils";
import { Auth } from "aws-amplify";
import { store, RootState } from "../../../redux/store";
import {
  setZwtToken,
  setUsername,
  setPermissions,
  setMonthlyRateReminder,
  resetUser,
} from "../../../redux/Slice/userSlice";
import { resetHotel } from "redux/Slice/hotelSlice";
import { resetState, setError } from "redux/Slice/state";

const revanista = {
  user: {
    identify: async () => {
      try {
        //refresh user
        let authData = await Auth.currentAuthenticatedUser({
          bypassCache: true,
        });
        console.log("auth data", authData);
        const currentUser = {
          username: AuthUtils.username(authData),
          permissions: AuthUtils.permissions(authData),
          monthlyRateReminder: AuthUtils.monthlyRateReminder(authData),
          zwtToken: AuthUtils.zwtToken(authData),
        };

        const monthlyReminderBool: boolean =
          currentUser.monthlyRateReminder === "true" ||
          currentUser.monthlyRateReminder === true;

        const state = store.getState() as RootState;
        if (state.user.username !== currentUser.username) {
          store.dispatch(setUsername(currentUser.username));
          store.dispatch(setPermissions(currentUser.permissions));
          store.dispatch(setMonthlyRateReminder(monthlyReminderBool));
          store.dispatch(setZwtToken(currentUser.zwtToken));
        }
        return currentUser;
      } catch (err) {
        store.dispatch(setError(true));
        return;
      }
    },
    signOut: (props: any) => {
      return Auth.signOut().then(() => {
        props.onStateChange("signedOut", null);
        store.dispatch(resetHotel());
        store.dispatch(resetState());
        store.dispatch(resetUser());
      });
    },
  },
};

const AuthService = {
  revanista: revanista,
};

export { AuthService };
